import React, { createContext, useEffect, useState } from "react";
import { changePasswordApi } from "../../../api/Api";
import { useCookies } from "react-cookie";
import ContentData from "../../../constants/contentFile.json";
import RouteConstants from "../../../constants/routeConstants.json";
import { useNavigate } from "react-router-dom";

export const ChangePasswordContext = createContext({});
export const ChangePasswordContextProvider = ({ children }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isMinLength, setIsMinLength] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasLowercase, setHasLowercase] = useState(false);
  const [hasUppercase, setHasUppercase] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [isPrevPassword, setIsPrevPassword] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [strengthBarMsg, setStrengthBarMsg] = useState("");
  const [confirmStrengthBarMsg, setConfirmStrengthBarMsg] = useState("");
  const [samePasswordMsg, setSamePasswordMsg] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [alertMessage, setAlertMessage] = useState("");
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);
  const [statusValue, setStatusValue] = useState();
  const [buttonText, setButtonText] = useState("");

  const navigate = useNavigate();

  const onChangeCurrentPassword = (event) => {
    setCurrentPassword(event.target.value);
  };
  useEffect(() => {
    if (confirmPassword && newPassword && currentPassword) {
      setDisableSubmitButton(false);
    }
  }, [confirmPassword, newPassword, currentPassword]);
  const onChangeNewPassword = (event) => {
    const password = event.target.value;
    setIsMinLength(password.length >= 8);
    setHasNumber(/[0-9]/.test(password));
    setHasLowercase(/[a-z]/.test(password));
    setHasUppercase(/[A-Z]/.test(password));
    setHasSpecialChar(/[!@#$%^&*(),.?":{}|<>]/.test(password));

    setNewPassword(password);
  };

  const onChangeConfirmPassword = (event) => {
    const value = event.target.value;
    setConfirmPassword(value);

    // Clear the message if passwords match
    if (value === newPassword) {
      setSamePasswordMsg("");
    }
  };

  const handleBlurConfirmPassword = () => {
    if (newPassword === confirmPassword) {
      setSamePasswordMsg("");
    } else {
      setSamePasswordMsg(ContentData.changePassword.notSamePasswords);
    }
  };

  const setConfirmPassBarColor = (index) => {
    if (confirmPassword.length >= 8 && index < 3) {
      setConfirmStrengthBarMsg("Strong");
      return "#13BC5B";
    }
    if (confirmPassword.length >= 6 && index < 2) {
      setConfirmStrengthBarMsg("Moderate");
      return "#EDB602";
    }
    if (confirmPassword.length >= 1 && index < 1) {
      setConfirmStrengthBarMsg("Weak");
      return "#EB5757";
    }
    return "#6b7a9933";
  };

  const setCurrentPassColor = (index) => {
    const strengthLevel = [
      isMinLength,
      hasLowercase,
      hasUppercase,
      hasSpecialChar,
      isPrevPassword,
      hasNumber,
    ].filter(Boolean).length;

    if (strengthLevel >= 6 && index < 3) {
      setStrengthBarMsg("Strong");
      return "#13BC5B";
    }
    if (strengthLevel >= 4 && index < 2) {
      setStrengthBarMsg("Moderate");

      return "#EDB602";
    }
    if (strengthLevel >= 2 && index < 1) {
      setStrengthBarMsg("Weak");
      return "#EB5757";
    }
    return "#6b7a9933";
  };

  const handleOnSubmit = () => {
    if (samePasswordMsg) {
      // setAlertMessage(samePasswordMsg);
      // setShowErrorPopup(true);
      return;
    }
    if (
      isMinLength &&
      hasLowercase &&
      hasUppercase &&
      hasSpecialChar &&
      hasNumber
    ) {
      changePassword(currentPassword, newPassword);
    } else {
    }
  };


  const goToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const changePassword = async (oldPassword, newPassword) => {
    try {
      const response = await changePasswordApi(oldPassword, newPassword);
      setAlertMessage(response?.data?.message);
      setShowSuccessPopup(true);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      const statusCode = error?.response?.data?.statusCode;
      setStatusValue(statusCode);
      setAlertMessage(errorMessage || "Something went wrong...");
      setShowErrorPopup(true);

      if (statusCode === 400) {
        setButtonText("Try Again");
        if (errorMessage === "You cannot reuse your last 3 passwords.") {
          setIsPrevPassword(false);
        } else {
          setIsPrevPassword(true);
        }
      } else if (statusCode === 401 || statusCode === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
  };

  // Old password is required
  // New password is required

  const passwordValueNull = () => {
    setConfirmPassword("");
    setCurrentPassword("");
    setNewPassword("");
  };

  const providerValue = {
    setCurrentPassword,
    setNewPassword,
    onChangeCurrentPassword,
    onChangeNewPassword,
    currentPassword,
    newPassword,
    handleOnSubmit,
    isMinLength,
    hasNumber,
    hasLowercase,
    hasUppercase,
    hasSpecialChar,
    isPrevPassword,
    showErrorPopup,
    setShowErrorPopup,
    alertMessage,
    confirmPassword,
    onChangeConfirmPassword,
    showSuccessPopup,
    setShowSuccessPopup,
    setConfirmPassBarColor,
    setCurrentPassColor,
    passwordValueNull,
    strengthBarMsg,
    confirmStrengthBarMsg,
    setStrengthBarMsg,
    samePasswordMsg,
    handleBlurConfirmPassword,

    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    disableSubmitButton,
  };
  return (
    <ChangePasswordContext.Provider value={providerValue}>
      {children}
    </ChangePasswordContext.Provider>
  );
};
